import { getRequest } from 'config/Axios/baseConfig';
import { ExtraDustyProductsInterface } from 'screens/StandardTimeLegend/components/ExtraDustyProducts/extraDustyProducts.types';

export const standardTimeLegendServices = {
  getExtraDustyProducts: async (): Promise<ExtraDustyProductsInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await getRequest<ExtraDustyProductsInterface>(
          'pps/drug-reference-concept-codes/super-dusty/'
        );
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
